import currencyFormatting from '@package/utils/src/currencyFormatting';
import { useRef } from 'react';
import usePayPalScriptLoader from '@package/hooks/src/usePayPalScriptLoader';
import dynamic from 'next/dynamic';

import SummaryItemsList from '../SummaryItemsList';

import styles from './CartSummaryCheckout.module.css';
import { CartSummaryCheckoutProps } from './types';

const CartSummaryPopup = dynamic(() => import('../CartSummaryPopup'), {
  ssr: false,
});

const CartSummaryCheckout = ({
  summary,
  notDeliverable = false,
  isUserAuthorized,
  redirectStart,
  showPayPal,
}: CartSummaryCheckoutProps) => {
  const summaryRef = useRef<any>(null);
  const { isFirstLoad } = usePayPalScriptLoader({ isPayPalAvailable: showPayPal, lazyLoad: true });

  return summary ? (
    <div data-testid={"cart-summary-checkout"} id="cart-summary-checkout" className={'orderSummary cartSummaryCheckout'} ref={summaryRef}>
      <SummaryItemsList summary={summary} />

      <div id="order-total" className={styles.summaryPrice}>
        <p className={styles.totalDue}>{'Order total'} (USD)</p>
        <span id="order-total-value" className={styles.totalDue}>
          {currencyFormatting(summary.totalDue, false)}
        </span>
      </div>

    {isFirstLoad && (
        <div className={styles.cartSummaryPopupContainer}>
          <CartSummaryPopup
            loading={redirectStart}
            notDeliverable={notDeliverable}
            checkoutButtonAvailable={summary.checkoutButtonAvailable}
            totalPrice={summary.subTotal}
            refElement={summaryRef}
            isUserAuthorized={isUserAuthorized}
            showPayPal={showPayPal}
          />
        </div>
      )}
    </div>
  ) : null;
};

export default CartSummaryCheckout;
